import { render, staticRenderFns } from "./BottomSheetDetalheManutencoes.vue?vue&type=template&id=0f176fd6&lang=true&"
import script from "./BottomSheetDetalheManutencoes.vue?vue&type=script&lang=js&"
export * from "./BottomSheetDetalheManutencoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports